module.exports = __webpack_public_path__ + "static/media/R-F-036.5278131e.webp";